import type { IPlatformLogger, ModuleLoader } from '@wix/thunderbolt-symbols'
import type { BootstrapData } from '../../types'
import type { IBuilderComponentSdkLoader } from '../types'
import { createSsrBuilderComponentSdkLoader } from './builderComponentSdkLoaders/ssrBuilderComponentSdkLoader'
import { createClientBuilderComponentSdkLoader } from './builderComponentSdkLoaders/clientBuilderComponentSdkLoader'
import { BOOTSTRAP_DATA, MODULE_LOADER, BUILDER_COMPONENT_SDK_LOADER, PLATFORM_LOGGER } from './moduleNames'

const BuilderComponentSdkLoader = (bootstrapData: BootstrapData, moduleLoader: ModuleLoader, logger: IPlatformLogger): IBuilderComponentSdkLoader => {
	const { builderPublicPackagesUrls, builderComponentsImportMapSdkUrls, experiments } = bootstrapData
	const isSSR = !process.env.browser
	const shouldDisableBuilderWixComponents = !!experiments['specs.thunderbolt.disableBuilderWixComponents']

	return isSSR ? createSsrBuilderComponentSdkLoader(moduleLoader, builderPublicPackagesUrls, shouldDisableBuilderWixComponents, builderComponentsImportMapSdkUrls, logger)
		: createClientBuilderComponentSdkLoader(builderPublicPackagesUrls, builderComponentsImportMapSdkUrls, shouldDisableBuilderWixComponents)
}

export default {
	factory: BuilderComponentSdkLoader,
	deps: [BOOTSTRAP_DATA, MODULE_LOADER, PLATFORM_LOGGER],
	name: BUILDER_COMPONENT_SDK_LOADER,
}
